module.exports = __webpack_public_path__ + "img/chevron-left-16px-dark.aa29036.svg";